import React from 'react';
import { getTabList } from './tabs';
import { Tabs } from '../../styles';
import useMagazineNewspaperTabs from './hooks/useMagazineNewspaperTabs';
import { FORM_TAB_GROUP_ARIA_LABEL } from '../constants';
export var MAGAZINE_FORM_TABS_ID = 'magazine-form-tabs';
export var MAGAZINE_FORM_TAB_TEST_ID = 'magazine-form-tab-test';

// Component to render Magazine and Newspaper form when "create manual citation" button is clicked
var MagazineNewspaperForm = function MagazineNewspaperForm(_ref) {
  var onSourceChange = _ref.onSourceChange,
    citation = _ref.citation,
    source = _ref.source;
  var _useMagazineNewspaper = useMagazineNewspaperTabs({
      intialPubtypeState: citation === null || citation === void 0 ? void 0 : citation.data.pubtype,
      source: source
    }),
    activeTabIndex = _useMagazineNewspaper.activeTabIndex,
    handleTabChange = _useMagazineNewspaper.handleTabChange;
  return /*#__PURE__*/React.createElement(Tabs, {
    tabs: getTabList(activeTabIndex, source, onSourceChange),
    activeTabIndex: activeTabIndex,
    id: MAGAZINE_FORM_TABS_ID,
    onChangeIndex: handleTabChange,
    "aria-label": FORM_TAB_GROUP_ARIA_LABEL,
    "data-test": MAGAZINE_FORM_TAB_TEST_ID
  });
};
export default MagazineNewspaperForm;